// extracted by mini-css-extract-plugin
export default {"warningModal":"ReportDraft_warningModal__0K8-1","buttonWrapper":"ReportDraft_buttonWrapper__kT3ax"};